module.exports = {
  templateUrl: 'signin/components/reset-password/reset-password.html',
  controller: class ResetPassword {

    static $inject =[
      '$scope',
      '$state',
      '$location',
      'RegistrationService',
      'PatientsService',
      'PatientAppContextService',
      'SessionService',
      'SecurityService',
    ];

    constructor($scope, $state, $location, RegistrationService, PatientsService, PatientAppContextService, SessionService, SecurityService) {
      this.$scope = $scope;
      this.$state = $state;
      this.$location = $location;
      this.RegistrationService = RegistrationService;
      this.PatientsService = PatientsService;
      this.PatientAppContextService = PatientAppContextService;
      this.SessionService = SessionService;
      this.SecurityService = SecurityService;
    }

    $onInit() {
      this.$scope.$on('auth:email-confirmation-error', () => {
        this.RegistrationService.states.forgotPassword.expired = true;
        this.$state.go('forgotten_password', this.$state.params);
      });

      this.loaded = true;
    }

    passwordUpdated = () => {
      this.saving = false;
      this.updated = true;
      if (this.PatientAppContextService.context.authenticatedPatient) {
        this.PatientAppContextService.context.authenticatedPatient.askedPasswordReset = false;
      }
      this.goToHome();
    };

    hasErrors(ngModel) {
      return this.RegistrationService.hasErrors(ngModel);
    }

    submit() {
      if (this.form.$valid) {
        this.saving = true;
        this.SessionService.updatePassword(this.password, this.$location.search().reset_token).then(this.passwordUpdated, this.updateFailed);
      }
    }

    updateFailed() {
      this.saving = false;
      this.updated = false;
    }

    confirmPassword = (callback) => {
      this.PatientsService.confirmPasswordChange(this.patientId(this.$location.search().reset_token), this.PatientAppContextService.context.group.id, 'confirmed', callback);
    };

    canSubmit() {
      return this.RegistrationService.canSubmit(this.form);
    }

    patientId(token) {
      const patientInfo = JSON.parse(atob(token.split('.')[1]));

      return patientInfo.patient;
    }

    goToHome = () => {
      this.$state.go('patients.id.home', {
        patientId: this.patientId(this.$location.search().reset_token),
        token: null,
      }, { reload: true });
    };

    cancel = () => {
      this.$state.go('login', this.$state.params);
    };
  },
};



// WEBPACK FOOTER //
// ./signin/components/reset-password/reset-password.js